import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';
import { UserInteractionState } from './state';

export const getUserInteraction = (state: RootInitialState): UserInteractionState => {
  return state.userInteraction;
};
